import facebookService from 'services/facebookService'
import tikTokService from 'services/tikTokService'
import heapService from 'services/heapService'
import googleAdsService from 'services/googleAdsService'

const adsFacade = {

  recordAddToCartEvent: ({ eventId, identity = {} }) => {
    facebookService.recordAddToCartEvent({ eventId })
    tikTokService.recordAddToCartEvent({ eventId })
    heapService.recordAddToCartEvent({ phone: identity.phone, email: identity.email })
    googleAdsService.recordAddToCartEvent({ phone: identity.phone, email: identity.email })
  },

  recordPurchaseEvent: ({ eventId, planType }) => {
    facebookService.recordPurchaseEvent({ eventId })
    tikTokService.recordPurchaseEvent({ eventId })
    googleAdsService.recordPurchaseEvent({ planType })
  }
}

export default adsFacade
